import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-name">Alina Bokovikova</div>
      <div className="footer-copy">© 2026 · Costume Design · San Francisco Bay Area</div>
    </footer>
  );
};

export default Footer;